import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class SegmentsProvider extends HttpRequest {
  async getSegmentsByFilterID (param) {
    return this.fetch(`/segments/${param}`)
  }

  getSegmentsWithOptions (options, id) {
    this.setHeader(getAuthToken())
    const params = [
      `page=${options.page}`
    ].join('&')
    return this.fetch(`/segments/${id}?${params}`)
  }

  deleteSegmentById (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/segments/${id}`)
  }
}

export default SegmentsProvider
